import React from 'react';
import styled, { withTheme } from 'styled-components'
import Intro from './snippets/Intro/Intro'
import TopImageText from './snippets/TopImageText'
import BottomImageText from './snippets/BottomImageText'
import Quote from './snippets/Quote'
import ExternalCta from './snippets/ExternalCta'


const Container = styled.div`
    background-color: ${props => props.backgroundColor};
`


const LandingContent = (props) => {
    return (
        <Container backgroundColor={props.backgroundColor}>
            <Intro
                cityName={props.cityName}
                mapImage={props.mapImage}
                mapImageAlt={props.mapImageAlt}
                pinImage={props.pinImage}
                pinImageAlt={props.pinImageAlt}
                bgPositionX={props.bgPositionX}
                bgPositionY={props.bgPositionY}
                pinPositionX={props.pinPositionX}
                pinPositionY={props.pinPositionY}
                mapBgColor={props.backgroundColor}
                introText={props.introText}>
            </Intro>
            <TopImageText
                text1={props.text1}
                image1Src={props.image1Src}
                image1Ref={props.image1Ref}
                photoSource={props.photoSource}
                image2Src={props.image2Src}
                image2Ref={props.image2Ref}
                image3Src={props.image3Src}
                image3Ref={props.image3Ref}
            ></TopImageText>
            <Quote
                quoteImageSrc={props.quoteImageSrc}
                quoteContent={props.quoteContent}
                quoteBg={props.quoteBg}>
            </Quote>
            <BottomImageText
                city={props.cityName}
                textBg={props.textBg}
                text2={props.text2}
                image4Src={props.image4Src}
                image4Ref={props.image4Ref}
                image5Src={props.image5Src}
                image5Ref={props.image5Ref}
                image6Src={props.image6Src}
                image6Ref={props.image6Ref}
                text3={props.text3}

                image7Src={props.image7Src}
                image7Ref={props.image7Ref}
                image8Src={props.image8Src}
                image8Ref={props.image8Ref}
                text4={props.text4}>
            </BottomImageText>
            <ExternalCta></ExternalCta>
        </Container>
    );
};

export default withTheme(LandingContent);